import { render, staticRenderFns } from "./LandingComponent.vue?vue&type=template&id=c12f981e"
import script from "./LandingComponent.vue?vue&type=script&lang=js"
export * from "./LandingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports